import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'aiops-terms-of-use-dialog',
  imports: [DialogModule, TranslatePipe],
  templateUrl: './terms-of-use-dialog.html',
})
export class TermsOfUseDialog {
  @Input() termsOfuseDialogVisible: boolean = false;
  @Output() termsOfuseDialogVisibleChange = new EventEmitter<boolean>();
}
